import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const fetchHome = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/home`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const putHome = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(`/home`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const putHomeModal = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(`/home/modal`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};
